import React from "react";
import HeroCardLayout from "../layout/HeroCardLayout";
import "../../styles/components/entryflow/UserTerminal.css";

interface UserTerminalComponentProps {
  reason: string | undefined;
}

const UserTerminalComponent: React.FC<UserTerminalComponentProps> = ({ reason }) => {
  return (
    <>
      <div className="userterminal-container">
        <div className="userterminal-status-message">{reason}</div>
      </div>
    </>
  );
};

const UserTerminalOnlyComponent: React.FC = () => {
  return (
    <HeroCardLayout>
      <UserTerminalComponent reason={"We couldn’t find the experience you were trying to open. It may no longer be available."} />
    </HeroCardLayout>
  );
};

export default UserTerminalComponent;
export { UserTerminalOnlyComponent };
